import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";


export const login = ({commit, dispatch}, payload) => {

    axios.post('/login/index.php', payload)
    .then(res => {
        
        if(res.data.status) {
            dispatch('storeAuthResponse', {data: res.data, goHome: true})
            
         } else {
            commit('setAlertBox', {title: 'Error', message: 'Login Failed'})
         }

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const changePassword = ({commit, dispatch}, payload) => {

    axios.post('/login/changePassword.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        console.log(JSON.stringify(res.data))
        if(res.data.status) {
            dispatch('logout')
        } else {
            commit('setAlertBox', {title: 'Error', message: res.data.message})    
        }
        

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const storeAuthResponse = ({commit}, payload) => {

    let accessToken = payload.data.access_token
    
    localStorage.setItem('accessToken', accessToken)
    commit('setUserauthResponse', payload.data)

    if(payload.goHome) {
        window.location = '/'
    }
    
}

export const tryAutoLogin = ({dispatch}) => {

    const accessToken = localStorage.getItem('accessToken')
    
    if(!accessToken) {
        return 
    }
    
    const postData = {access_token: accessToken}
    
    axios.post('/login/autoLogin.php', postData)
    .then(res => {
        
        if(res.data.status) {
            dispatch('storeAuthResponse', {data: res.data, goHome: false})
        } else {
            dispatch('logout')
        }

    })
    .catch(error => {
       
    })
    
}

export const logout = ({commit}) => {

    
    axios.get('/login/logout.php', accessTokenInfo.accessTokenInfo())
    .then(res => {

        commit('clearAuthData')
        localStorage.removeItem('accessToken')
        window.location = '/login'
        
    })
    .catch(error => {
        console.log(error)
        commit('setAlertBox', {title: 'Error', message: 'Error: ¡Inténtalo de nuevo!'})                
    })
    
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js